import { createStyles } from 'antd-style';

const useStyles = createStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'stretch',
    gap: 12,
    height: '100%',
    maxHeight: '100%',
    boxSizing: 'border-box',
    lineHeight: 1,
    color: 'inherit',
  },
  logo: {
    display: 'block',
    flexShrink: 0,
    width: '40px !important',
    height: '40px !important',
    objectFit: 'contain',
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 2,
    color: '#fff',
  },
  brandIdentity: {
    fontSize: 24,
    fontWeight: 600,
    lineHeight: '34px',
    letterSpacing: 5,
  },
  systemName: {
    fontSize: 12,
    fontWeight: 400,
  },
}));

export default useStyles;
